"use client";
import { jsx as n } from "react/jsx-runtime";
import a from "clsx";
import { memo as l, Children as p } from "react";
import { Box as c } from "../../blocks/base/Base.js";
import { s as t } from "../../Button.module-C3Ja-wjg.js";
const d = l(
  ({ activeButton: r = 0, color: e = "gray", wide: m, children: o, ...i }) => {
    const s = p.count(o);
    return /* @__PURE__ */ n(
      c,
      {
        gap: 4,
        row: !0,
        className: a(
          t.setV2,
          t[e],
          t["children_" + s],
          t["active_" + r],
          { [t._wide]: m }
        ),
        ...i,
        children: o
      }
    );
  }
);
d.displayName = "ButtonSetSlide";
export {
  d as ButtonSetSlide
};
